import { AutoSubmitFormController, useInjectedHTML } from 'stimulus-library';

export default class extends AutoSubmitFormController {

  submit(event) {
    useInjectedHTML(this, this.el, 'afterbegin', `<input type="hidden" name="auto-submitted" value="true">`, {cleanup: false});
    super.submit(event);
  }

}